import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
/**
 * Delete component
 */
var DeleteComponent = (function () {
    function DeleteComponent(activeRoute, router, translateService, userService) {
        var _this = this;
        this.activeRoute = activeRoute;
        this.router = router;
        this.translateService = translateService;
        this.userService = userService;
        this.ngUnsubscribe = new Subject();
        this.activeRoute.params.takeUntil(this.ngUnsubscribe).subscribe(function (params) {
            /** Set users selected language for text translations */
            _this.translateService.setDefaultLang(params.language);
            _this.translateService.use(params.language);
            _this.userService
                .deleteUser(params.token)
                .catch(function (error) {
                /** On error go to login page */
                _this.router.navigate(['/login']);
            });
        });
    }
    /**
     * On destroy cancel active subscriptions
     */
    DeleteComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return DeleteComponent;
}());
export { DeleteComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/delete/delete.component.ts.pre-build-optimizer.js